'use client';

import { c as _c } from "react/compiler-runtime";
import type { SyntheticEvent } from 'react';
import { type ConsentType, getConsent, giveConsent } from '@/helpers/consent';
import { useNextDialog } from './useNextDialog';

/**
 * Hook for managing consent dialog state and interactions.
 * @param type - Type of consent to manage
 * @returns Consent state and event handlers for confirm/continue
 */
export const useConsentDialog = type => {
  const $ = _c(12);
  let t0;
  if ($[0] !== type) {
    t0 = getConsent(type);
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const consentStatus = t0;
  const nextDialog = useNextDialog();
  let t1;
  if ($[2] !== consentStatus || $[3] !== nextDialog || $[4] !== type) {
    t1 = function onClickConfirm(event) {
      event.preventDefault();
      if (!consentStatus) {
        giveConsent(type);
      }
      nextDialog();
    };
    $[2] = consentStatus;
    $[3] = nextDialog;
    $[4] = type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onClickConfirm = t1;
  let t2;
  if ($[6] !== nextDialog) {
    t2 = function onClickContinue(event_0) {
      event_0.preventDefault();
      nextDialog();
    };
    $[6] = nextDialog;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onClickContinue = t2;
  let t3;
  if ($[8] !== consentStatus || $[9] !== onClickConfirm || $[10] !== onClickContinue) {
    t3 = {
      consentStatus,
      onClickConfirm,
      onClickContinue
    };
    $[8] = consentStatus;
    $[9] = onClickConfirm;
    $[10] = onClickContinue;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};